import { AppBar } from "@mui/material";
// import styled from "@emotion/styled"
import { styled } from "@mui/material/styles";

export const StyledAppBar = styled(AppBar)(() => ({
  backgroundColor: "#000000",
}));

export const NavbarImgLogo = styled("img")(() => ({
  maxHeight: "100px",
  maxWidth: "180px",
  width: "auto",
  height: "auto",
  margin: "7px",
  borderRadius: "25px",
}));
